export default __webpack_public_path__ + "static/media/placeholder.dfe90314.svg";